<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Registrar Nueva Forma de pago</v-toolbar>
        <v-card-text>
          <v-container class="mt-1">
            <v-text-field label="Nombre" v-model.trim="forma.nombre" dense outlined></v-text-field>
            <v-text-field label="Descripcion" v-model.trim="forma.descripcion" dense outlined></v-text-field>

            <v-select
              label="Codigo clasificador SIN"
              v-model="forma.codigo_clasificador_SIN"
              :items="metodos"
              item-value="codigo"
              @change="onCodigoClasificador"
              dense
              outlined
            ></v-select>

            <!-- <v-text-field
              label="Descripcion SIN"
              color="green"
              readonly
              v-model.trim="forma.descripcion_SIN"
              dense
              outlined
            ></v-text-field> -->

            <v-progress-linear indeterminate v-if="loading" />
            <p class="text-center red--text">{{ msg }}</p>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="save()" class="green darken-2" dark :disabled="loading">
            {{ forma.id ? 'Actualizar' : 'Registrar' }}
          </v-btn>
          <v-btn text @click="dialog.value = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        msg: '',
        metodos: [],
        forma: {
          id: null,
          nombre: '',
          descripcion: '',
          codigo_clasificador_SIN: null,
          descripcion_SIN: null,
        },
      };
    },
    components: {},
    watch: {},
    methods: {
      openmodal(item) {
        this.msg = '';
        this.dialog = true;
        this.forma.id = null;
        this.forma.nombre = '';
        this.forma.descripcion = '';
        this.forma.codigo_clasificador_SIN = null;
        this.forma.descripcion_SIN = null;
        this.getmetodos();
        if (item) {
          this.forma.id = item.id;
          this.forma.nombre = item.nombre;
          this.forma.descripcion = item.descripcion;
          this.forma.codigo_clasificador_SIN = item.codigo_clasificador_SIN;
          this.forma.descripcion_SIN = item.descripcion_SIN;
        }
      },

      onCodigoClasificador() {
        let codigo = this.metodos.find((x) => x.codigo == this.forma.codigo_clasificador_SIN);
        this.forma.descripcion_SIN = codigo.descripcion;
        window.console.log(this.forma);
      },

      getmetodos() {
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/catalogo/metodopago`,
          headers: {
            apikey: this.$store.getters.getApiKey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            data.sort((a, b) => {
              let x = parseInt(a.codigo);
              let y = parseInt(b.codigo);
              return x - y;
            });
            data.map((x) => {
              x.codigo = parseInt(x.codigo);
              x.text = `(${x.codigo}) - ${x.descripcion}`;
            });
            window.console.log(data);
            vue.metodos = data;
          })
          .catch(function(error) {
            window.console.log(error);
          });
      },

      save() {
        this.msg = '';
        if (!this.forma.nombre) this.msg = 'Ingrese un nombre.';
        if (!this.forma.descripcion) this.msg = 'Ingrese una descripcion.';
        if (this.msg) return;

        this.loading = true;
        let metodo = 'post';
        if (this.forma.id) metodo = 'put';
        const vue = this;
        var config = {
          method: metodo,
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/formaspagos`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: this.forma,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('formanew::', data);
            if (data.data) {
              vue.msg = data.data;
              vue.$emit('newregforma', vue.forma);
            }
            vue.loading = false;
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
    },
  };
</script>
